export enum PStepperStatus {
  DEFAULT = 'default',
  ACTIVE = 'active',
  COMPLETED = 'completed',
}
